/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OperatorStats } from './OperatorStats';
import {
    OperatorStatsFromJSON,
    OperatorStatsFromJSONTyped,
    OperatorStatsToJSON,
    OperatorStatsToJSONTyped,
} from './OperatorStats';

/**
 * 
 * @export
 * @interface PaginatedOperatorStatsList
 */
export interface PaginatedOperatorStatsList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedOperatorStatsList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedOperatorStatsList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedOperatorStatsList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<OperatorStats>}
     * @memberof PaginatedOperatorStatsList
     */
    results: Array<OperatorStats>;
    /**
     * 
     * @type {number}
     * @memberof PaginatedOperatorStatsList
     */
    numPages?: number;
}

/**
 * Check if a given object implements the PaginatedOperatorStatsList interface.
 */
export function instanceOfPaginatedOperatorStatsList(value: object): value is PaginatedOperatorStatsList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedOperatorStatsListFromJSON(json: any): PaginatedOperatorStatsList {
    return PaginatedOperatorStatsListFromJSONTyped(json, false);
}

export function PaginatedOperatorStatsListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedOperatorStatsList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] === undefined ? undefined : json['next'] === null ? null : json['next'],
        'previous': json['previous'] === undefined ? undefined : json['previous'] === null ? null : json['previous'],
        'results': ((json['results'] as Array<any>).map(OperatorStatsFromJSON)),
        'numPages': json['num_pages'] == null ? undefined : json['num_pages'],
    };
}

export function PaginatedOperatorStatsListToJSON(json: any): PaginatedOperatorStatsList {
    return PaginatedOperatorStatsListToJSONTyped(json, false);
}

export function PaginatedOperatorStatsListToJSONTyped(value?: PaginatedOperatorStatsList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(OperatorStatsToJSON)),
        'num_pages': value['numPages'],
    };
}

